import { createContext, useEffect, useRef, type PropsWithChildren } from "react";
import { RequestQueryMapper } from "util/request-query-mapper";
import { Filters } from "consts/transactions";
import { TabLayout } from "ui/widgets/StatefulTabs";
import type { IRepository, RepositoryProps, RepositoryState } from "./types";
import { useTransactionContext } from "../../TransactionProvider";

export const RepositoryContext = createContext<IRepository>({} as IRepository);

const Repository = <TState extends RepositoryState>({
    children,
    repository,
    ...restProps
}: PropsWithChildren<RepositoryProps<TState>>) => {
    const transaction = useTransactionContext();
    const transactionRef = useRef(transaction);
    transactionRef.current = transaction;

    const repositoryRef = useRef(repository);
    repositoryRef.current = repository;

    useEffect(() => {
        const {
            transactionId,
            transactionGuid
        } = transactionRef.current;

        repositoryRef.current
            .init(
                RequestQueryMapper.from()
                    .contains(Filters.transactionId, transactionId)
                    .contains(Filters.transactionGuid, transactionGuid)
            );
    }, []);

    return (
        <RepositoryContext.Provider
            value={repository}
        >
            <TabLayout
                {...restProps}
            >
                {children}
            </TabLayout>
        </RepositoryContext.Provider>
    );
};

export default Repository;
